import { useEffect } from "react";
import { PrivacyPolicyContent } from "@/components/ec/PrivacyPolicy";
import { DocLink, DocMetaItem, DocumentSection } from "@/components/ec/documentSection";

export function EcPrivacyPolicyPage() {
  useEffect(() => {
    const prev = document.title;
    document.title = "Privacy Policy — Autranslate | Monobundle Inc.";
    return () => {
      document.title = prev;
    };
  }, []);

  return (
    <DocumentSection
      title="Privacy Policy — Autranslate"
      lastUpdated="May 28, 2026"
      appName="Autranslate (オートラ | SEO/GEO対応翻訳AI)"
      extraMeta={
        <>
          <DocMetaItem label="Service provider:">Shorbai inc.</DocMetaItem>
          <DocMetaItem label="Contact:">
            <DocLink href="mailto:yosui262@gmail.com">yosui262@gmail.com</DocLink>
          </DocMetaItem>
        </>
      }
    >
      <PrivacyPolicyContent />
    </DocumentSection>
  );
}
